/**
 * Splits a leading markdown heading (`##`/`###`) off a text block: the
 * heading becomes the card title, the remainder the body.
 */
export const splitLeadingHeading = (
  text: string
): { title: string | null; body: string } => {
  const headingMatch = text.match(/^#{2,3}\s+(.+?)(?:\n|$)/);
  return {
    title: headingMatch?.[1]?.trim() ?? null,
    body: headingMatch ? text.slice(headingMatch[0].length).trimStart() : text,
  };
};
